import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      display: 'flex',
      flexDirection: 'column',
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      minHeight: 56,
      py: [6, 8],
      px: 8,
    };

    this.header = {
      mb: ['12px', '16px'],
    };

    this.scroll = {
      flexWrap: ['noWrap', 'wrap'],
      justifyContent: ['flex-start', 'center'],
      width: '100%',
      height: '100%',
      overflowY: 'hidden',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      webkitOverflowScrolling: 'touch',
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
      pb: 3,
      '::-webkit-scrollbar': {
        display: 'auto',
      },
    };

    this.link = {
      mb: [0, 3],
      variant: 'text.label.1',
      minWidth: 'auto',
      height: 32,
      px: 11,
      bg: 'gray',
      lineHeight: 32,
      whiteSpace: 'nowrap',
      borderRadius: 16,
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out',
      ':hover': {
        bg: 'mediumGray',
      },
    };
  })()
);
